import { getConfig, setConfig } from '../utils/configUtils';

let audioPrimed = false;

let audioPrimedFunc;

let serverUrl;
let lockProxyHost;
let reloadTimeStr;

let useFirestoreMode = false;

let mbotConfig = {invalid:true};

//TODO looks like this is no longer really used, kill it if so
export function getServerUrl() {
  if (!serverUrl) {
    if (!getConfig().protocol) throw new Error('getServerUrl: no protocol specified');
    if (window.location.hostname)
      serverUrl = `${getConfig().protocol}://` + window.location.hostname + ':' + getConfig().serverPort;
  }
  if (!serverUrl) {
    console.log('getServerUrl called early');
    return undefined;
  }
  return serverUrl;
}

const enableDebug = false;

let debugLogs = [];
let lastLogTime = Date.now();

export function debugLog(msg) {
  if (!enableDebug) return;
  debugLogs.push(msg);
  if (debugLogs.length > 400) debugLogs = debugLogs.slice(debugLogs.length - 400);
}

export function getDebugLogs() {
  if (!enableDebug) return undefined;
  return { debugLogs, lastLogTime };
}

export const pickupTaskType = 'pickup';
export const dropoffTaskType = 'dropoff';

export function setLockProxyHost(host) {
  lockProxyHost = host;
}

export function getLockProxyHost() {
  return lockProxyHost;
}

export function setReloadTimeStr(timeStr) {
  reloadTimeStr = timeStr;
}

export function getReloadTimeStr() {
  return reloadTimeStr;
}

export function setAudioPrimedHook(hookFunc) {
  audioPrimedFunc = hookFunc;
}

export function setAudioPrimed() {
  let wasPrimed = audioPrimed;
  audioPrimed = true; //important to do before calling audioPrimedFunc
  if (!wasPrimed) {
    console.log('Audio is now primed.');
    if (audioPrimedFunc) audioPrimedFunc();
  }
}

export function getAudioPrimed() {
  return audioPrimed;
}


export function setMbotConfig(mbotConfigParam) {
  mbotConfig = mbotConfigParam;
}

export function getMbotConfig() {
  return mbotConfig;
}


export function setUseFirestore(useFirestoreParam) {
  useFirestoreMode = !!useFirestoreParam;
}

export function getUseFirestore() {
  return useFirestoreMode;
}

